"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'operateData',
  components: {
    Pagination: _Pagination.default
  },
  data: function data() {
    return {
      agentInfo: {},
      list: [],
      listLoading: true,
      listQuery: {
        sel_agent_level: this.$route.query.l || 0,
        start: 1,
        total: 10,
        limit: 20,
        page_num: 1,
        date_range: [] // 添加时间范围字段
      }
    };
  },
  mounted: function mounted(options) {
    this.agentInfo = window.agentInfo;
    this.getList();
  },
  methods: {
    /**
     * 运营数据类型筛选
     * @param {Object} val
     */
    selDataType: function selDataType(tab) {
      this.listQuery.sel_agent_level = tab.name;
      this.listQuery.start = 1;
      this.getList();
    },
    /**
     * 处理日期变更
     */
    handleDateChange: function handleDateChange() {
      this.listQuery.start = 1;
      this.getList();
    },
    getList: function getList() {
      var _this = this;
      var listQuery = Object.assign({}, this.listQuery, {
        start: this.listQuery.start - 1
      });

      // 添加日期参数
      if (listQuery.date_range && listQuery.date_range.length === 2) {
        listQuery.start_date = listQuery.date_range[0];
        listQuery.end_date = listQuery.date_range[1];
        // 删除原始的date_range数组参数
        delete listQuery.date_range;
      }
      this.listLoading = true;
      this.$get('agentapi/my_total_business_data', listQuery).then(function (res) {
        _this.list = res.list;
        _this.listQuery.page_num = res.page_num;
      }).catch(function () {
        // 错误处理
      }).finally(function () {
        _this.listLoading = false;
      });
    }
  }
};